import { Injectable } from '@angular/core';
import { Resolve, Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { CompetitionService } from 'app/services/competition.service';
import { Competition } from 'app/models/competition';
import { Observable, of } from 'rxjs';
import { map, catchError } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class CompetitionsResolver implements Resolve<Competition[]> {
  constructor(private competitionService: CompetitionService, private router: Router) {}

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<Competition[]> {
    const id = route.paramMap.get('id');
    return this.competitionService.getAll(id).pipe(
      map(res => {
        this.competitionService.setCompetitions(res);
        return res;
      }),
      catchError(() => {
        this.competitionService.setCompetitions([]);
        return of([]);
      })
    );
  }
}
